import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import { Link } from "react-router";
import Slider from "common/components/slick_slider";
import Image from "common/components/image";
import { MOBILE_BREAKPOINT_PX, DESKTOP_BREAKPOINT_PX } from "common/variables";

const CASE_STUDIES = [
  {
    company: "Sanders",
    description:
      "Sanders & Son saved thousands of dollars and rebranded their business for $500 with crowdspring. They were blown away by the results.",
    image:
      "https://crowdspring3-assets.s3.amazonaws.com/marketing/sanders-logo.png",
    url: "/case-studies/case-study-sanders/",
    background: "#000630",
  },
  {
    company: "Bog Street",
    description:
      "Bog Street Guitars got a massive amount of value and a unique brand story when they created a new guitar accessories brand on crowdspring.",
    image:
      "https://crowdspring3-assets.s3.amazonaws.com/marketing/bog-street-logo-white.png",
    url: "/case-studies/case-study-bogstreet/",
    background: "#4394BA",
  },
  {
    company: "Asabasa",
    description:
      "Asabasa had to rebrand to avoid trademark infringement. They saved tens of thousands of dollars by using crowdspring instead of an agency.",
    image:
      "https://crowdspring3-assets.s3.amazonaws.com/marketing/asabasa-logo-white.png",
    url: "/case-studies/case-study-asabasa/",
    background: "#A57B49",
  },
  {
    company: "ASPE",
    description:
      "Action Sports and Power Equipment rebranded and created a van wrap to impress customers and prospects as they drove all over California.",
    image:
      "https://crowdspring3-assets.s3.amazonaws.com/marketing/ASPE-logo-white.png",
    url: "/case-studies/case-study-aspe/",
    background: "#000630",
  },
  {
    company: "High Stats",
    description:
      "Asia Bird created a custom design on crowdspring for her mobile app, High Stats, to track a user's marijuana experience, with impressive results.",
    image:
      "https://crowdspring3-assets.s3.amazonaws.com/marketing/high-stats-logo-white.png",
    url: "/case-studies/case-study-highstats/",
    background: "#4394BA",
  },
  {
    company: "ABCR",
    description:
      "America's Best Coffee refreshed their wholesale coffee bag packaging design with a fresh look that stood out against competitors.",
    image:
      "https://crowdspring3-assets.s3.amazonaws.com/marketing/americasbestcoffee-logo-white.png",
    url: "/case-studies/case-study-americasbestcoffee/",
    background: "#A57B49",
  },
  {
    company: "AliExpress",
    description:
      "Sellers on AliExpress leverage crowdspring for product design, clothing design, packaging design, and more, to stand out against competitors.",
    image:
      "https://crowdspring3-assets.s3.amazonaws.com/marketing/aliexpress-logo-white-2.png",
    url: "/case-studies/case-study-aliexpress/",
    background: "#000630",
  },
  {
    company: "Bootheel",
    description:
      "Bootheel Catering created a fresh brand and used crowdspring's free focus group tool to build customer excitement and get design feedback.",
    image:
      "https://crowdspring3-assets.s3.amazonaws.com/marketing/bootheel-logo-white.png",
    url: "/case-studies/case-study-bootheel/",
    background: "#4394BA",
  },
  {
    company: "LG",
    description:
      "LG partnered with crowdspring for a series of annual competitions to create unique and powerful product designs for a mobile phone.",
    image:
      "https://crowdspring3-assets.s3.amazonaws.com/marketing/lg-logo-white.png",
    url: "/case-studies/case-study-lg/",
    background: "#A57B49",
  },
];

const CaseStudies2 = ({ background }) => {
  return (
    <section className={cn("block block-case-studies-2", background)}>
      <div className="row columns">
        <div className="block-header">
          <h2>Real brands, real results</h2>
        </div>
      </div>
      <Slider
        arrowsVersion="v1"
        infinite={false}
        slidesToShow={3}
        slidesToScroll={1}
        responsive={[
          {
            breakpoint: MOBILE_BREAKPOINT_PX,
            settings: { slidesToShow: 1, dots: true },
          },
          {
            breakpoint: DESKTOP_BREAKPOINT_PX,
            settings: { slidesToShow: 2 },
          },
        ]}
      >
        {CASE_STUDIES.map((study, i) => (
          <div key={i}>
            <div
              className="case-study"
              style={{ background: study.background }}
            >
              <Image src={study.image} alt={study.company} />

              <p>{study.description}</p>

              <Link to={study.url}>
                Discover how {study.company} succeeded{" "}
                <i className="fa fa-long-arrow-right" />
              </Link>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

CaseStudies2.propTypes = {
  background: PropTypes.string,
};

export default CaseStudies2;
